var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
export function PageTitle(_a) {
    var title = _a.title;
    return (_jsxs("div", __assign({ className: cn("hidden w-full max-w-[856px] max-h-[120px] py-11 pl-14 rounded", "bg-etipi-blue", "sm:flex", "relative") }, { children: [_jsx("h1", __assign({ className: "text-2xl text-light-gray " }, { children: title })), _jsx("img", { src: "/driving-car.png", alt: "Imagem de uma pessoa dirigindo", className: "absolute right-0 bottom-0 rounded-r-[8px]" }), _jsx("div", { className: "w-[280px] h-full absolute right-0 bottom-0 bg-gradient-to-r from-[rgba(3,_78,_162)] to-[rgba(3,_78,_162,_.5)] rounded-r-[8px]" })] })));
}
